<template>
  <Select
    v-model="selectedChildId"
    :options="options"
    optionLabel="label"
    optionValue="value"
    :placeholder="childrenLoading ? 'Loading…' : 'Select child'"
    :loading="childrenLoading && !children.length"
    :disabled="!children.length"
    :size="size"
    :fluid="fluid"
    :aria-label="'Child to view'"
    data-testid="child-switcher"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Select from 'primevue/select';
import { useGuardianPortalContext } from '@/composables/guardianPortal/useGuardianPortalContext';
import { childFullName } from '@/utils/guardianPortal';

withDefaults(defineProps<{ size?: 'small' | 'large'; fluid?: boolean }>(), { size: undefined, fluid: true });

const { children, selectedChildId, childrenLoading } = useGuardianPortalContext();

const options = computed(() => children.value.map(child => ({
  value: String(child.student.id),
  label: childFullName(child.student),
})));
</script>
